import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material';


const card = (
    <React.Fragment>
        <CardContent>
            <Typography variant="h5" component="div" align='center'>
                แจ้งเตือน...!
            </Typography>
            <Typography variant="body2" align='center'>
                กำลังปรับปรุงระบบ ขออภัยในความไม่สะดวกครับ
            </Typography>
        </CardContent>
        <CardActions>
            <Button size="small" onClick={e => location.reload()}>รีโหลด</Button>
        </CardActions>

    </React.Fragment >
);

export default function Improve() {
    return (
        <Container maxWidth="sm">
            <Box sx={{ minWidth: 275, mt: '50%' }} >
                <Card variant="outlined">{card}</Card>
            </Box>
        </Container >
    );
}